import { DisabledHint } from '@/components/common/DisabledHint';
import { Button } from '@/components/ui/button';

export type RowActionTone = 'default' | 'destructive';

const BUTTON_VARIANT_BY_TONE = {
  default: 'outline',
  destructive: 'destructive',
} as const satisfies Record<RowActionTone, 'outline' | 'destructive'>;

interface RowActionButtonProps {
  label: string;
  ariaLabel: string;
  onClick: () => void;
  tone?: RowActionTone;
  isDisabled?: boolean;
  disabledHint?: string | undefined;
}

export function RowActionButton({
  label,
  ariaLabel,
  onClick,
  tone = 'default',
  isDisabled = false,
  disabledHint,
}: RowActionButtonProps) {
  const button = (
    <Button
      variant={BUTTON_VARIANT_BY_TONE[tone]}
      size="sm"
      aria-label={ariaLabel}
      disabled={isDisabled}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
    >
      {label}
    </Button>
  );

  if (!isDisabled || !disabledHint) return button;

  return (
    <DisabledHint hint={disabledHint} ariaLabel={ariaLabel}>
      {button}
    </DisabledHint>
  );
}
